export default "__VITE_ASSET__NgcqOOiN__"